import {
  Typography,
  Card,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid2,
  Divider,
  Tooltip,
  Button,
} from "@mui/material";
import { formatAge, showLoadingImage } from "../Utility/Utility";
import GeneralPrescriptionReadOnlyView from "./GeneralPrescriptionReadOnlyView";
import PhysiotherapyPrescriptionReadOnly from "./PhysiotherapyPrescriptionReadOnly";
import FrozenShoulderPrescriptionReadOnly from "./FrozenShoulderPrescriptionReadOnly"; // ✅ ADD THIS IMPORT
import FollowUpNotes from "./FollowUpNotes";
import { useSnackbar } from "../Utility/UserMessageContext";
import AuthContext from "../Context/AuthProvider";
import { useContext, useState } from "react";
import { viewPrescriptionById } from "../API/PrescriptionApi";
import { PrescriptionTypes } from "../Utility/Constants";
import Menubar from "../common/MenuBar";
import LabReportReadOnlyView from "./LabReportReadOnlyView";
import LaboratoryTestReportReadOnly from "./LaboratoryTestReportReadOnly";

function PrescriptionReadOnlyView({ prescriptionId, prescriptionType }) {
  const { showSnackbar } = useSnackbar();
  const { auth } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const viewPrescription = async () => {
    setIsLoading(true);
    try {
      if (auth != null && prescriptionId != null) {
        await viewPrescriptionById(auth, prescriptionId);
      }
    } catch (error) {
      showSnackbar("Error viewing prescription: " + error.message, "error");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Grid2 container size={12}>
        {/* Single MenuBar for all prescription types */}
        <Grid2 container size={12} width={"100%"} paddingTop={0}>
          <Menubar onDownload={viewPrescription} showDownload={true} />
        </Grid2>

        <Grid2 container size={12}>
          {prescriptionId &&
            prescriptionType === PrescriptionTypes.GeneralPrescription && (
              <GeneralPrescriptionReadOnlyView
                prescriptionId={prescriptionId}
              />
            )}
          {prescriptionId &&
            prescriptionType ===
              PrescriptionTypes.PhysiotherapyPrescription && (
              <PhysiotherapyPrescriptionReadOnly
                prescriptionId={prescriptionId}
              />
            )}
          {prescriptionId &&
            prescriptionType === PrescriptionTypes.PathologyLabReport && (
              <LaboratoryTestReportReadOnly prescriptionId={prescriptionId} />
            )}
          {/* Pass showMenuBar={false} to prevent duplicate menu */}
          {prescriptionId &&
            prescriptionType === PrescriptionTypes.FrozenShoulder && (
              <FrozenShoulderPrescriptionReadOnly
                prescriptionId={prescriptionId}
                showMenuBar={false}
              />
            )}
        </Grid2>
      </Grid2>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(216, 214, 214, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1301,
          }}
        >
          {showLoadingImage()}
        </div>
      )}
    </>
  );
}

export default PrescriptionReadOnlyView;
